// Davet/sıfırlama sayfalarının açılış kontrolü — POST /auth/activation-status (2026-10-20).
// Token yokken çağrı yapılmaz (sayfa kendi "link eksik" dalını gösterir). Uç hata verirse
// form gösterilir (fail-open — lib/activation-link-ui.ts). Unmount/token değişiminde sonuç atılır.

import { useEffect, useState } from "react";
import { getActivationStatus } from "../api/auth";
import {
  activationGateFromError,
  resolveActivationGate,
  type ActivationGate,
} from "../lib/activation-link-ui";

export type ActivationGateState = { mode: "checking" } | ActivationGate;

export function useActivationGate(token: string): ActivationGateState {
  const [state, setState] = useState<ActivationGateState>(() =>
    token ? { mode: "checking" } : { mode: "form" },
  );

  useEffect(() => {
    if (!token) {
      setState({ mode: "form" });
      return;
    }
    let cancelled = false;
    setState({ mode: "checking" });
    getActivationStatus(token)
      .then((res) => {
        if (!cancelled) setState(resolveActivationGate(res));
      })
      .catch((err: unknown) => {
        if (!cancelled) setState(activationGateFromError(err));
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  return state;
}
